import { Observable } from 'rxjs';

import { StoreRemovalQueue } from 'app/model';
import { RestfulApiService } from 'app/services';
import { ModelPrepped, ModelWithoutId } from 'app/type';

class StoreRemovalService extends RestfulApiService<StoreRemovalQueue> {
    public commit(queue: StoreRemovalQueue): Observable<void> {
        return this.http.post(`${this.getAlterUrl(queue)}/commit`, {});
    }

    public rollback(queue: StoreRemovalQueue): Observable<void> {
        return this.http.post(`${this.getAlterUrl(queue)}/rollback`, {});
    }

    protected getFormName(): string {
        return 'store_keyword';
    }

    protected getPath(): string {
        return `store-queue`;
    }

    protected prepareSaveData(entity: ModelWithoutId<StoreRemovalQueue>): ModelPrepped<StoreRemovalQueue> {
        return {
            ...entity,
        };
    }
}

export const storeRemovalService = new StoreRemovalService();
